import { apiService } from './index';

// Inport types
import { ISelectType } from '../shared/types/select-type';

export const asyncGetDepartments = async (
    country: string
): Promise<ISelectType[]> => {
    const { items }: any = await apiService.get(
        `/api/department/by-country/${country}`
    );
    return items || [];
};
